import React from "react";

const IntervistaFushaDinamike = () => {
  return <div>IntervistaFushaDinamike</div>;
};

export default IntervistaFushaDinamike;
